import classNames from "classnames"
import { AnchorHTMLAttributes, ButtonHTMLAttributes, PropsWithChildren } from "react"

type LinkAttributes = AnchorHTMLAttributes<HTMLAnchorElement>
type ButtonAttributes = ButtonHTMLAttributes<HTMLButtonElement>
type RestProps = {
  className?: string
  color?: 'black' | 'gray' |'white'
  size?: 'sm' | 'md'
  href?: string
}

type Props = PropsWithChildren<RestProps> & (LinkAttributes | ButtonAttributes)

export const Button = (props: Props) => {
  const { className, color, children, size, href, ...rest } = props

  const nextProps = {
    className: classNames(
      {
        "p-3": size === "sm",
        "py-4 px-3": size === "md",
        "Button Button--tertiary xl-max:hover:bg-ink xl-max:hover:text-reverse xl-max:active:bg-ink xl-max:active:text-reverse": color === "black",
        "text-black bg-[#ebebeb]": color === "gray",
        "text-black bg-white": color === "white",
      },
      "rounded-sm",
      className
    ),
    ...(href ? { href } : {}),
    ...rest
  }

  if (href) {
    return <a className="active:bg-ink" {...nextProps as RestProps & LinkAttributes}>{children}</a>
  }

  return <button {...nextProps as RestProps & ButtonAttributes}>{children}</button>
}